import HomeRoutes from "./home";
import AuthRoutes from "./auth";
import NotFoundRoute from "./notFound";
import UnauthorizedRoute from "./unauthorized";

const Routes = [
  ...HomeRoutes,
  ...AuthRoutes,
  ...UnauthorizedRoute,
  ...NotFoundRoute,
];
export default Routes;
